
import { Link, useLocation } from 'react-router-dom';
import {
  User,
  ShoppingBag,
  // CreditCard,
  // Settings,
  LogOut
} from 'lucide-react';
import { DOMAIN } from '../../../config.tsx';
import jsCookie from 'js-cookie';

const ProfileSidebar = () => {
  const location = useLocation();

  const menuItems = [
    { icon: User, label: 'Личный кабинет', path: '/profile' },
    { icon: ShoppingBag, label: 'Мои заказы', path: '/profile/orders' },
    // { icon: CreditCard, label: 'Бонусная программа', path: '/profile/bonus' },
    // { icon: Settings, label: 'Настройки', path: '/profile/settings' },
  ];

  const handleLogout = () => {
    if (typeof window !== 'undefined') {
      jsCookie.remove('user', { path: '/', domain: DOMAIN });
      window.location.href = '/';
    }
  };

  return (
    <div className="w-full rounded-lg bg-white p-4 shadow">
      <nav>
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`flex items-center rounded-md px-3 py-2 transition-colors ${
                  location.pathname === item.path 
                    ? 'bg-autoparts-orange text-white' 
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                <item.icon className="mr-3 h-5 w-5" />
                <span>{item.label}</span>
              </Link>
            </li>
          ))}

          <li className="mt-4 pt-4 border-t border-gray-200">
            <button onClick={handleLogout} className="flex w-full items-center rounded-md px-3 py-2 text-gray-700 transition-colors hover:bg-gray-100">
              <LogOut className="mr-3 h-5 w-5 text-red-500" />
              <span>Выйти</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default ProfileSidebar;
